export { default } from './Mark';
export { StyledMark } from './Mark';
